/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LatestSubscribersDto } from '../../models/latest-subscribers-dto';

export interface GetLatestSubscribers$Params {
}

export function getLatestSubscribers(http: HttpClient, rootUrl: string, params?: GetLatestSubscribers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LatestSubscribersDto>>> {
  const rb = new RequestBuilder(rootUrl, getLatestSubscribers.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LatestSubscribersDto>>;
    })
  );
}

getLatestSubscribers.PATH = '/api/editorial/latest-subscribers';
